export const CollapseUpIcon = ({ color = "#A7A7A7", size = 10, ...props }) => (
    <svg
        width={size}
        height={size * (6 / 10)}
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.24219 5.24219L4.99955 0.999547L0.756906 5.24219"
            stroke={color}
        />
    </svg>
);
